"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var monthNames = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];
function isValidDate(date) {
    return !isNaN(date.getTime());
}
exports.isValidDate = isValidDate;
function leftPadZero(value) {
    if (value < 10) {
        return "0" + value;
    }
    return value.toString();
}
exports.leftPadZero = leftPadZero;
function getTime(date) {
    return leftPadZero(date.getHours()) + ":" + leftPadZero(date.getMinutes());
}
exports.getTime = getTime;
function mapDayToString(date, now) {
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (now.getFullYear() !== date.getFullYear() || now.getMonth() !== date.getMonth()) {
        return undefined;
    }
    if (now.getDate() === date.getDate()) {
        return 'сегодня';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'вчера';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'позавчера';
    }
    return undefined;
}
exports.mapDayToString = mapDayToString;
function getFormattedDate(date, now) {
    var day = mapDayToString(date);
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (day) {
        return day + " " + getTime(date);
    }
    if (now.getFullYear() === date.getFullYear()) {
        return date.getDate() + " " + monthNames[date.getMonth()] + " " + getTime(date);
    }
    return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
}
exports.getFormattedDate = getFormattedDate;



//////////////////
// WEBPACK FOOTER
// ./src/shared/date_time.ts
// module id = 5
// module chunks = 0